import { Pipe, PipeTransform } from '@angular/core';
import { RoiService } from '../service/roi.service';

@Pipe({
  name: 'damageSizeRange'
})
export class DamageSizeRangePipe implements PipeTransform {
  constructor(
    private readonly _roiService: RoiService
  ) { }

  transform(value, args?: any): any {
    if (typeof value === 'string') {
      let index = this._roiService.damageSizeRange.findIndex(range => { return range.key === value })
      if (index < 0)
        return value
      else
        return this._roiService.damageSizeRange[index].value || ''
    } else {
      value /= 10;
      for (let index = 0; index < this._roiService.damageSizeRange.length; index++) {
        const sev = this._roiService.damageSizeRange[index];
        if (sev.range.length === 2) {
          if (value >= sev.range[0] && value < sev.range[1]) {
            return sev.value
          }
        } else {
          if (value >= sev.range[0])
            return sev.value
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/damage-size-range.pipe.ts